module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 col-md-6 col-sm-12 col-xs-12 package-wrapper"
  }, [_c('div', {
    staticClass: "card-shadow bg-deveo-light",
    class: 'card-' + _vm.type
  }, [(_vm.header === 'vue-toastr') ? _c('div', {
    staticClass: "most-popular"
  }, [_c('i', {
    staticClass: "fa fa-star fa-fw"
  }), _vm._v(" Most popular\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-logo"
  }, [(_vm.type === 'vue') ? _c('img', {
    staticClass: "grey",
    attrs: {
      "src": "/static/images/techicons/vue_grey.svg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'vue') ? _c('img', {
    staticClass: "white",
    attrs: {
      "src": "/static/images/techicons/vue_white.svg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'laravel') ? _c('img', {
    staticClass: "grey",
    attrs: {
      "src": "/static/images/techicons/laravel_grey.svg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'laravel') ? _c('img', {
    staticClass: "white",
    attrs: {
      "src": "/static/images/techicons/laravel_white.svg"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.header))]), _vm._v(" "), _vm._t("description"), _vm._v(" "), _c('div', {
    staticClass: "card-downloads"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.downloads !== '' && _vm.downloads !== 0) ? _c('div', {
    staticClass: "col-lg-6 col-xs-6"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-download"
  }), _vm._v(" " + _vm._s(_vm.downloads) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.stars !== '' && _vm.stars !== 0) ? _c('div', {
    staticClass: "col-lg-6 col-xs-6"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-star"
  }), _vm._v(" " + _vm._s(_vm.stars) + "\n                ")]) : _vm._e()])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-626b0d29"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/technology/components/package.vue
// module id = 312
// module chunks = 1